import apiLibrary from './apiLibrary';

const API = {
    getExternalLinks() {
        return apiLibrary.get('/api/persistent-data/external-links');
    },
    setExternalLinks(links) {
        return apiLibrary.post('/api/persistent-data/external-links', links);
    },
};

export default API;
